import { useState } from 'react';
import { faqs } from '@/mocks/content';

export default function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full scroll-mt-20 bg-[#fffbf5] py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <span className="text-sm font-medium text-orange-600">常见问题</span>
            <h2 className="font-heading mt-2 text-2xl md:text-4xl font-bold text-stone-900">
              关于完整版与版本的那些疑问
            </h2>
            <p className="mt-4 text-stone-600 leading-relaxed">
              下面这些是观众在查找完整版、未删减与高清修复资源时最常问到的问题，点击即可展开查看。
            </p>
            <div className="mt-6 bg-white border border-stone-200 rounded-xl p-5 flex items-start gap-3">
              <i className="ri-question-line text-orange-500 text-xl mt-0.5" aria-hidden="true"></i>
              <p className="text-sm text-stone-600">
                没有找到想问的问题？可以先把上面几个分区的思路过一遍，多数情况都能对号入座。
              </p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ul className="space-y-3">
              {faqs.map((item, i) => {
                const isOpen = open === i;
                return (
                  <li key={item.q} className="bg-white border border-stone-200 rounded-xl overflow-hidden">
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? null : i)}
                      aria-expanded={isOpen}
                      className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer hover:bg-orange-50/60 transition-colors"
                    >
                      <span className="font-heading text-base md:text-lg font-semibold text-stone-900">
                        {item.q}
                      </span>
                      <i
                        className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} text-xl text-orange-500 shrink-0`}
                        aria-hidden="true"
                      ></i>
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-5 -mt-1">
                        <p className="text-sm text-stone-600 leading-relaxed">{item.a}</p>
                      </div>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}